import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { upChannel, addChannel, uploadChannel } from "@/api/channel";
export default {
  data: function data() {
    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入'));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error('输入不能包含大写字母和中文!'));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      form: {
        channel_name: "",
        status: "1",
        channel_mark: ""
      },
      rules: {
        channel_name: [{
          required: true,
          message: "请输入渠道名称",
          trigger: "blur"
        }],
        channel_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    // 打开修改新增
    init: function init(id, num) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$upChannel, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (num == 1) {
                  _this.titleName = "添加渠道";
                  _this.form.id = _this.id;
                  _this.form = {
                    channel_name: "",
                    status: "1",
                    channel_mark: ""
                  };
                }

                _this.id = id;

                if (!(id != "t")) {
                  _context.next = 14;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 14;
                  break;
                }

                _this.titleName = "修改渠道";
                tid = {
                  id: id
                };
                _context.next = 9;
                return upChannel(tid);

              case 9:
                _yield$upChannel = _context.sent;
                data = _yield$upChannel.data;
                _this.form.channel_name = data.channel_name;
                _this.form.status = String(data.status);
                _this.form.channel_mark = data.channel_mark;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          if (_this2.titleName == "添加渠道") {
            _this2.form.id = null; // 这是添加不需要传id

            addChannel(_this2.form).then(function (res) {
              if (res.status == 200) {
                Message.success('操作成功');

                _this2.$emit("refreshDataList");

                _this2.resetForm("ruleForm");
              }
            });
          }

          if (_this2.titleName == "修改渠道") {
            _this2.form.id = _this2.id;
            uploadChannel(_this2.form).then(function (res) {
              if (res.status == 200) {
                Message.success('操作成功');

                _this2.$emit("refreshDataList");

                _this2.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};